import { Component, h, State, Prop, Element, Watch, getAssetPath, Host } from '@stencil/core';
import '../../../stories/Components/MessageBubble/DocumentMessageBubble/DocumentMessageBubble';
import '../../../stories/Components/MessageBubble/ImageMessageBubble/ImageMessageBubble';
import '../../../stories/Components/MessageBubble/VideoMessageBubble/VideoMessageBubble';
import '../../../stories/Components/MessageBubble/IncomingTextMessageBubble/IncomingTextMessageBubble';
import '../../../stories/Components/MessageBubble/OutgoingTextMessageBubble/OutgoingTextMessageBubble';
import { getDeviceID } from '../../../lib/helpers';
import { formatMessageDateFromTimestamp } from '../../../utils/getFomattedDate';
import '../../../stories/Components/MessageDatePill/MessageDatePill';
import '../../../stories/Components/Loader/Spinner/Spinner';
import ChatSDK from 'test-iso-chat-sdk';
import '../../../global/dark-theme.css'
@Component({
  tag: 'chat-body',
  shadow: true,
  styles: `
  :host {
   flex-grow: 1;
    overflow: hidden;
    display: flex;
     background-color: var(--chat-body-bg);
}
     

    #outgoing-message > * {
      display: flex;
      width: 100%;
      justify-content: end;
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #F9E3FF !important;
      border-radius: 10px;
    }
    .popup {
      position: absolute;
      bottom: 100%;
      box-shadow: 0px 0px 10px 0px GRAY;
      z-index: 10;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      width: 30% !important;
      gap: 16px !important;
      background-color: #FFFFFF;
      font-family: 'Roboto';
      padding: 10px;
      font-weight:500;
      border-radius: 8px;
    }

    .popup span {
      cursor: pointer;
    }
    #outgoing-message .kebab-menu {
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    #outgoing-message:hover .kebab-menu {
      opacity: 1;
    }

    .deleteText {
      font-size: 14px;
      font-weight: 700;
    }
  `,
})
class ChatBody {
  @State() isSelf: Boolean = false;
  @Prop() conversationId: string;
  @Prop() skip: number;
  @Prop() isDark?: boolean;
  @Prop() allMessages: any;
  @Prop() userMetaData: any;
  @Prop() isMessagesLoading: boolean;
  @Prop() isMessageSending: boolean;
  @Prop() isMessageLimitEnd: boolean;
  @Prop() updateSkip: () => void;
  @Prop() isScrollToBottom: boolean;
  @Prop() isScrollToTop: boolean;
  @Prop() deleteForAll: ({ conversationId, messageIds }) => void;
  @Prop() deleteForSelf: ({ conversationId, messageIds }) => void;
  @Prop() changeScrollToBottomState: (newState: boolean) => void;
  @Prop() changeScrollToTopState: (newState: boolean) => void;
  @Prop() updateAllMessages: (newMessages: any) => void;
  @Prop() isChatClosed: boolean;
  @Prop() isChatMinimized: boolean;
  @Element() chatBodyElement: HTMLElement; // Reference to the chat-body element
  @State() previousTotalScrollHeight: number = 0;
  @State() deviceId: string = '';
  @State() scrollTimeout: any = null;
  @State() isPopupOpen: String | null = null;
  @State() deletedMessages: Set<string> = new Set();
  @State() isTabActive: boolean = true;

  openPopup = (event: Event, messageId: string) => {
    event.stopPropagation();
    this.isPopupOpen = this.isPopupOpen === messageId ? null : messageId;
  };

  deleteMessageForSelf(messageId) {
    this.deleteForSelf({ conversationId: this.conversationId, messageIds: messageId });
    this.isPopupOpen = null;
  }

  deleteMessageForEveryone(messageId) {
    this.deleteForAll({ conversationId: this.conversationId, messageIds: messageId });
    this.isPopupOpen = null;
  }

  async componentWillLoad() {
    const deviceId = await getDeviceID();
    this.deviceId = deviceId;
  }

  // Function to handle scroll event and trigger API call when scrolled near the bottom
  handleScroll = () => {
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    if (chatBodyDiv) {
      const scrollTop = chatBodyDiv.scrollTop;
      if (scrollTop === 0 && !this.isMessageLimitEnd) {
        this.updateSkip();
      }

      // if (this.scrollTimeout) {
      //   clearTimeout(this.scrollTimeout);
      // }
      // this.scrollTimeout = setTimeout(() => {
      // }, 300);
      this.onScrollEnd();
    }
  };

  onScrollEnd = () => {
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    const scrollTop = chatBodyDiv.scrollTop;
    this.previousTotalScrollHeight = chatBodyDiv.scrollHeight - scrollTop;
  };

  // Function to scroll the chat body to the bottom
  scrollToBottom = () => {
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    const scrollTop = chatBodyDiv.scrollTop;
    if (chatBodyDiv) {
      setTimeout(() => {
        chatBodyDiv.scrollTop = chatBodyDiv.scrollHeight; // Scroll to the bottom
        this.previousTotalScrollHeight = chatBodyDiv.scrollHeight - scrollTop;
      }, 200);
    }
  };

  scrollToTop = () => {
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    if (chatBodyDiv) {
      setTimeout(() => {
        const toScroll = chatBodyDiv.scrollHeight - this.previousTotalScrollHeight;
        chatBodyDiv.scrollTop = toScroll;
        this.previousTotalScrollHeight = chatBodyDiv.scrollHeight;
      }, 0);
    }
  };

  putReadAll = async () => {
    const hasUnreadMessages = this.allMessages.some(message => (message?.senderId || message?.senderInfo?.userId) != this.userMetaData?.userId && !message.readByAll);
    if (hasUnreadMessages) {
      await ChatSDK.getInstance().message.putRead({ conversationId: this.conversationId });
      const newUpdatedAllMessages = this.allMessages?.map(message =>
        message?.readByAll != true && (message?.senderId || message?.senderInfo?.userId) != this.userMetaData?.userId ? { ...message, readByAll: true } : message,
      );
      this.updateAllMessages(newUpdatedAllMessages);
    }
  };

  handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      this.isTabActive = true;
      this.putReadAll();
    } else {
      this.isTabActive = false;
    }
  };

  // Add a new method to handle document clicks
  handleDocumentClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.popup') && !target.closest('.kebab-menu')) {
      this.isPopupOpen = null;
    }
  };

  // Attach the scroll listener after the component has loaded
  async componentDidLoad() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    document.addEventListener('click', this.handleDocumentClick);
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    if (chatBodyDiv) {
      chatBodyDiv.addEventListener('scroll', this.handleScroll); // Listen to the scroll event
    }
    this.scrollToBottom();
    this.putReadAll();
  }

  @Watch('allMessages')
  @Watch('userMetaData')
  async handleDataChange() {
    if (this.isScrollToBottom && this.allMessages.length > 0 && this.userMetaData?.userId) {
      this.scrollToBottom();
      this.changeScrollToBottomState(false);
    } else if (this.allMessages.length > 0 && this.userMetaData?.userId && !this.isScrollToBottom && this.isScrollToTop) {
      this.scrollToTop();
      this.changeScrollToTopState(false);
    }

    if (!this.isChatMinimized && !this.isChatClosed && this.isTabActive) {
      this.putReadAll();
    }
  }

  // Clean up the scroll listener when the component is removed
  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    document.removeEventListener('click', this.handleDocumentClick);
    const chatBodyDiv = this.chatBodyElement.shadowRoot.querySelector('.chat-body');
    if (chatBodyDiv) {
      chatBodyDiv.removeEventListener('scroll', this.handleScroll); // Remove the scroll listener
    }
  }

  render() {

    const backgroundImage = getAssetPath('https://isometrik-website-bucket.s3.ap-south-1.amazonaws.com/chat_BG_8a53348931.png');
    return (
      <Host>
      <div
      id='lol'
        class="chat-body chat-body-bg"
        style={{
          backgroundColor: 'var(--chat-body-bg)',
          backgroundImage: `url(${backgroundImage})`,
          display: 'flex',
          flexGrow: '1',
          flexDirection: 'column',
          gap: '20px',
          padding: '10px 15px 35px 10px',
          overflowY: 'scroll',
        }}
      >
        {this.isMessagesLoading && (
          <spinner-loader height="20px" width="20px" spinTime="1s" spinnerPrimaryColor="#000" spinnerSecondaryColor="#F9E3FF" spinnerBorderWidth="3px"></spinner-loader>
        )}

        {this.allMessages.length > 0 &&
          this.userMetaData?.userId &&
          this.allMessages.map((message: any, index: number) => {
            const currentMessageDate = formatMessageDateFromTimestamp(this.allMessages[index].sentAt);
            const previousMessageDate = formatMessageDateFromTimestamp(this.allMessages[index - 1]?.sentAt || '');

            const showDatePill = currentMessageDate !== previousMessageDate;

            if (message.attachments) {
              return (
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '15px' }}>
                  {showDatePill && (
                    <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                      <message-date-pill borderRadius={'9px'} textColor={'var(--chat-date-pill-text)'} bgColor={'var(--chat-date-pill-bg)'} padding={'5px 20px'} content={currentMessageDate}></message-date-pill>
                    </div>
                  )}
                  {message.attachments.map((attachment: any) => {
                    if ((message?.senderId || message?.senderInfo?.userId) == this.userMetaData?.userId) {
                      return (
                        <div id="outgoing-message" style={{ position: 'relative', display: 'flex', width: '100%', justifyContent: 'right' }}>
                          {attachment.mimeType.startsWith('application/') ? (
                            <document-message
                              docType={attachment.mimeType}
                              fileName={attachment.name}
                              href={attachment.mediaUrl}
                              bgColor= {'var(--chat-outgoing-msg-bg)'}
                              width="220px"
                              padding="10px 10px 30px 10px"
                              borderRadius="6px"
                              time={message?.sentAt}
                              docName={attachment.name}
                              isRead={message.readByAll}
                              isSelf={true}
                              isDelivered={`${message?.deliveredToAll}`}
                            />
                          ) : attachment.mimeType.startsWith('video/') ? (
                            <video-message
                              height={'180px'}
                              width={'200px'}
                              padding="10px 10px 20px 10px"
                              bgColor={'var(--chat-outgoing-msg-bg)'}
                              isSelf={true}
                              borderRadius="6px"
                              time={message?.sentAt}
                              type={attachment.mimeType}
                              videoSrc={attachment.mediaUrl}
                              isRead={message.readByAll}
                              isDelivered={`${message?.deliveredToAll}`}
                            />
                          ) : attachment.mimeType.startsWith('image/') ? (
                            <image-message
                              bgColor={'var(--chat-outgoing-msg-bg)'}
                              padding="10px 10px 20px 10px"
                              isSelf={true}
                              borderRadius="6px"
                              time={message?.sentAt}
                              imageSrc={attachment.mediaUrl}
                              height={'150px'}
                              width={'150px'}
                              isRead={message.readByAll}
                              borderWidth={'5px'}
                              borderColor={'var(--chat-outgoing-msg-bg)'}
                              borderStyle={'solid'}
                              isDelivered={`${message?.deliveredToAll}`}
                            />
                          ) : (
                            ''
                          )}
                          <span
                            class="kebab-menu"
                            style={{ cursor: 'pointer', position: 'absolute', right: '-12px ', top: '5px' }}
                            onClick={e => this.openPopup(e, message?.messageId)}
                          >
                            <svg width="14px" height="14px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill={'var(--chat-msg-info-icon)'} class="bi bi-three-dots-vertical">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                              </g>
                            </svg>
                          </span>
                          {this.isPopupOpen === message?.messageId ? (
                            <div class="popup">
                              <span class="deleteText" onClick={() => this.deleteMessageForSelf(message?.messageId)}>
                                Delete For Me
                              </span>
                              <span class="deleteText" onClick={() => this.deleteMessageForEveryone(message?.messageId)}>
                                Delete For All
                              </span>
                            </div>
                          ) : null}
                        </div>
                      );
                    } else {
                      return (
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'left' }}>
                          {attachment.mimeType.startsWith('application/') ? (
                            <document-message
                              docType={attachment.mimeType} 
                              fileName={attachment.name}
                              href={attachment.mediaUrl}
                              bgColor={'var(--chat-incoming-msg-bg)'}
                              width="220px"
                              padding="10px 10px 30px 10px"
                              borderRadius="6px"
                              time={message?.sentAt}
                              docName={attachment.name}
                              isSelf={false}
                            />
                          ) : attachment.mimeType.startsWith('video/') ? (
                            <video-message
                              height={'180px'}
                              width={'200px'}
                              bgColor={'var(--chat-incoming-msg-bg)'}
                              padding="10px 10px 20px 10px"
                              borderRadius="6px"
                              isSelf={false}
                              time={message?.sentAt}
                              type={attachment.mimeType}
                              videoSrc={attachment.mediaUrl}
                            />
                          ) : attachment.mimeType.startsWith('image/') ? (
                            <image-message
                              bgColor={'var(--chat-incoming-msg-bg)'}
                              padding="10px 10px 20px 10px"
                              borderRadius="6px"
                              isSelf={false}
                              time={message?.sentAt}
                              imageSrc={attachment.mediaUrl}
                              height={'150px'}
                              width={'150px'}
                              borderWidth={'5px'}
                              borderColor= {'var(--chat-incoming-msg-bg)'}
                              borderStyle={'solid'}
                            />
                          ) : (
                            ''
                          )}
                        </div>
                      );
                    }
                  })}
                </div>
              );
            } else if (message.body) {
              if ((message?.senderId || message?.senderInfo?.userId) == this.userMetaData?.userId) {
                return (
                  <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '15px' }}>
                    {showDatePill && (
                      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <message-date-pill borderRadius={'9px'} textColor= {'var(--chat-date-pill-text)'} bgColor={'var(--chat-date-pill-bg)'} padding={'5px 20px'} content={currentMessageDate}></message-date-pill>
                      </div>
                    )}
                    <div id="outgoing-message" style={{ position: 'relative', display: 'flex', width: '100%', justifyContent: 'end' }}>
                      <outgoing-text-message-bubble
                      msgTextColor = {'var(--chat-outgoing-msg-text)'}
                      msgTextTimeColor = {'var(--chat-outgoing-msg-time-text)'}
                        isRead={message.readByAll}
                        padding="10px 10px 1px 10px"
                        borderRadius="10px 10px 0 10px"
                        textContent={message?.body}
                        time={message?.sentAt}
                        bgColor={'var(--chat-outgoing-msg-bg)'}
                        isDelivered={`${message?.deliveredToAll}`}
                      />
                      <span
                        class="kebab-menu"
                        style={{ cursor: 'pointer', position: 'absolute', right: '-12px ', top: '5px' }}
                        onClick={e => this.openPopup(e, message?.messageId)}
                      >
                        <svg width="14px" height="14px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill={'var(--chat-msg-info-icon, #000)'} class="bi bi-three-dots-vertical">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
                          </g>
                        </svg>
                      </span>
                      {this.isPopupOpen === message?.messageId ? (
                        <div class="popup">
                          <span class="deleteText" onClick={() => this.deleteMessageForSelf(message?.messageId)}>
                            Delete For Me
                          </span>

                          <span class="deleteText" onClick={() => this.deleteMessageForEveryone(message?.messageId)}>
                            Delete For All
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '15px' }}>
                    {showDatePill && (
                      <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                        <message-date-pill borderRadius={'9px'} textColor= {'var(--chat-date-pill-text)'} bgColor={'var(--chat-date-pill-bg)'} padding={'5px 20px'} content={currentMessageDate}></message-date-pill>
                      </div>
                    )}
                    {/* <div style={{ display: 'flex', width: '100%', justifyContent: 'start', ma }}> */}
                    <incoming-text-message-bubble bgColor={'var(--chat-incoming-msg-bg)'} msgTextTimeColor={'var(--chat-incoming-msg-time-text)'} msgTextColor={'var(--chat-incoming-msg-text)'} borderRadius="10px 10px 10px 0" time={message?.sentAt} textContent={message?.body} />
                    {/* </div> */}
                  </div>
                );
              }
            } else if (message.action == 'conversationCreated') {
              return (
                <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
                  {showDatePill && <message-date-pill borderRadius={'9px'} textColor= {'var(--chat-date-pill-text)'} bgColor= {'var(--chat-date-pill-bg)'} padding={'5px 20px'} content={currentMessageDate}></message-date-pill>}
                </div>
              );
            }
          })}
        {/* {this.isMessageSending && <h3>Uploading...</h3>} */}
      </div>
      </Host>
    );
  }
}

export { ChatBody };
